// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__Je92j","text":"Loading_text__-xHk-"};